import React from 'react';
import { Avatar } from 'antd';
import Wrapper from './style';
import { getNickName } from '../../utils/commonUtils';
import { DocumentsHooks } from '../../hooks';

const AccountCard = (props) => {
  const {
    name = '',
    description,
    disabled,
    srcAvatar,
    fontRegular,
    className,
    componentCustom,
    sizeAvatar = 40,
    onClick,
    profilePicDocument,
  } = props;

  const { url: profileUrl } =
    DocumentsHooks.useGetImageDocument(profilePicDocument);

  const profilePictureUrl = profileUrl || srcAvatar;

  return (
    <Wrapper
      className={
        className
          ? `${className} component_accountCard`
          : 'component_accountCard'
      }
      disabled={disabled}
      aria-hidden="true"
      onClick={onClick}
    >
      {profilePictureUrl ? (
        <Avatar size={sizeAvatar} src={profilePictureUrl} />
      ) : (
        <Avatar size={sizeAvatar}>{getNickName(name)}</Avatar>
      )}
      <div>
        {componentCustom && componentCustom}
        {!componentCustom && (
          <div className={`font-paragraph${!fontRegular && '_medium'} black2`}>
            {name}
          </div>
        )}
        {description && (
          <div className="font-caption black3 component_account_card_description">
            {description}
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default AccountCard;
